'use strict';/*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Editor} from '../../../shared/editor/editor';
import {Settings_context} from '../settings_ctx';
import {use_screen} from '../lib/screen_util';
import {Button} from '../../../shared/button';
import {use_download} from '../shared/use_download';
import {Svg_img} from '../ui/svg_img';
import {img_url} from '../ui/img_url';
import styles from './fast_pace_gaming_banner.module.less';
import cn from 'classnames';

const badges = ['Low latency', 'Reduced packet loss', 'Consistent gameplay'];

interface i_fast_pace_gaming_banner_props {
    title: string;
    subtitle: string;
    section_title: string;
    section_text: string;
    button_text: string;
    download_type?: string;
}

export const Fast_pace_gaming_banner = (
props: i_fast_pace_gaming_banner_props)=>{
    const {title, subtitle, section_title, section_text, button_text,
        download_type = 'gameboost'} = props;
    const {theme} = useContext(Settings_context);
    const {screen} = use_screen();
    const is_mobile = screen=='xs' || screen=='sm';
    const {download, download_gameboost} = use_download();
    const on_download = ()=>{
        if (download_type=='gameboost')
            return void download_gameboost();
        download();
    };
    return <div className={styles.wrapper}>
      <div className={styles.header}>
        <h2 className={styles.title}>{title}</h2>
        <p className={cn([theme.u3, styles.subtitle])}>{subtitle}</p>
      </div>
      <div className={styles.content}>
        <div className={styles.text_block}>
          <h3 className={cn([theme.H5, theme.color_n700])}>{section_title}</h3>
          <p className={cn([theme.p3, theme.color_n600])}>{section_text}</p>
        </div>
        <div className={styles.diagram_card}>
          <img className={styles.diagram_img}
            src={img_url(is_mobile ? 'hola2023/conn_diagram_mob.png'
              : 'hola2023/conn_diagram.png')} alt="" />
          <div className={styles.badges}>
            {badges.map(b=>
              <div key={b} className={styles.badge}>
                <Svg_img id={'hola2023/icons/18/check_gray.svg'} w={16}
                  h={16} />
                <p className={cn([theme.p4, theme.med, theme.color_n600])}>
                  {b}</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={styles.cta}>
        <Button on_click={on_download} caption={button_text}
          color="black2023"
          size={is_mobile ? 'md' : 'lg'}
          round />
        <p className={cn([theme.p4, theme.color_n600, theme.text_center])}>
          {'Free download  \u2022  No login required  \u2022  Install in'
              +' under 1 minute'}</p>
      </div>
    </div>;
};

interface i_fast_pace_gaming_banner_editor_props {
    value: i_fast_pace_gaming_banner_props;
    on_change: (new_val: i_fast_pace_gaming_banner_props)=>void;
}

export const Fast_pace_gaming_banner_editor = (
{value, on_change}: i_fast_pace_gaming_banner_editor_props)=>{
    return <Editor value={value} on_change={on_change}
      editors={[
        {key: 'title', label: 'Title (h2)', type: 'text'},
        {key: 'subtitle', label: 'Subtitle', type: 'text'},
        {key: 'section_title', label: 'Section title', type: 'text'},
        {key: 'section_text', label: 'Section text', type: 'textarea'},
        {key: 'button_text', label: 'Button text', type: 'text'},
        {key: 'download_type', label: 'Download type (gameboost / vpn)',
          type: 'text'},
      ]}/>;
};
